import React from 'react';
import { IconButton, Typography, useTheme } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import ModeNightIcon from '@mui/icons-material/ModeNight';
import { useTranslation } from 'react-i18next';
import { ThemeDomain } from './theme.domain';
import { di } from '../../state/inversify.config';

interface ToggleThemeSwitchProps {
  label?: string;
}

export const ToggleThemeSwitch = ({ label = '' }: ToggleThemeSwitchProps) => {
  const themeDomain = di.get<ThemeDomain>(ThemeDomain);
  const currentTheme = themeDomain.useThemeSelector();
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <IconButton
      onClick={() =>
        themeDomain.dispatchSetTheme(currentTheme === 'dark' ? 'light' : 'dark')
      }
      color="inherit"
      aria-label={t('accessibility.TOGGLE_THEME')}
    >
      {currentTheme === 'dark' ? (
        <ModeNightIcon
          fontSize="large"
          sx={{ fill: theme.palette.text.primary }}
        />
      ) : (
        <LightModeIcon
          fontSize="large"
          sx={{ fill: theme.palette.text.primary }}
        />
      )}

      {label && (
        <Typography variant="subtitle1" sx={{ ml: 1 }}>
          {label}
        </Typography>
      )}
    </IconButton>
  );
};
